<template>
  <div style="height: 100%">
    <TableMain name="TempQuotationTable" ref="TempQuotationTable" :fields="fields" :title="table_title.title"
      :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="false" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
      :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query"
      :show_toolbar_button="[0, 0, 1, 1, 0, 0, 0, 1]" :hb_table_class="'hb_table_quotationorder_class1'"
      @tool_invoke="tool_invoke" @state_change="state_change" @on_cell_button_click="on_cell_button_click"
      @current_changed="current_changed" tableref="cb368c57c0d14f769ab9d7f286fcb0f7">
      <template #toolbar>
        <div style="display: inline-block">
          <el-button type="info" plain @click="createData" class="ml-2 iconfont icon-add-new" size="mini">
            {{ $t('common.new') }}
          </el-button>
          <el-button type="info" plain class="ml-2" @click="showInventView"><i
              class="iconfont icon-add-new"></i>&nbsp;&nbsp;选择物料
          </el-button>
          <el-button type="info" plain class="ml-2" @click="createTempItem"><i
              class="iconfont icon-add-new"></i>&nbsp;&nbsp;创建临时物料
          </el-button>
        </div>
      </template>
      <template #query>
        <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
          align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions()">
        </el-date-picker>
        <el-select placeholder="销售公司" size="small" v-model="dataAreaId" filterable clearable class="w-5 ml-1">
          <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
            :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
        </el-select>
        <el-select size="small" v-model="tempApplyNum" filterable remote reserve-keyword :remote-method="QTRemoteMethod"
          clearable @clear="QTRemoteMethod('')" @focus="QTRemoteMethod('')" placeholder="请输入报价申请编号关键词" class="w-5 ml-1">
          <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
        </el-select>
      </template>
    </TableMain>
    <BaseModal ref="QTModal" :title="new_temp_quotation_modal" @saveData="SaveData" :width="'35%'">
      <template #modal_content>
        <el-form :rules="rules" :model="new_temp_quotation_model" ref="dataForm" label-width="120px"
          class="demo-dataForm">
          <el-form-item label="客户账户" prop="AccountNum">
            <el-select size="small" v-model="new_temp_quotation_model.AccountNum" filterable clearable
              :placeholder="`请选择`" class="w-100" :filter-method="filterMethod"
              @focus="filterMethod(new_temp_quotation_model.AccountNum)"
              @change="CustChanged(new_temp_quotation_model.AccountNum)">
              <el-option v-for="citem in cust_options" :key="citem.AccountNum"
                :label="citem.AccountNum + ':' + citem.SEI_Name" :value="citem.AccountNum"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售公司" prop="dataAreaId">
            <el-select placeholder="销售公司" size="small" v-model="new_temp_quotation_model.dataAreaId" filterable
              clearable class="w-100">
              <el-option v-for="item in $store.state.biz_data.baseData.CompanyInfo" :key="item.DataArea"
                :label="item.DataArea + ':' + item.CompanyName" :value="item.DataArea"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报价类型" prop="quotationType">
            <el-select v-model="new_temp_quotation_model.quotationType" size="small" style="width: 100%" clearable
              filterable :placeholder="'请选择报价类型'">
              <el-option label="大货报价" value="大货报价"></el-option>
              <el-option label="打样报价" value="打样报价"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报价名称" prop="quotationName">
            <el-input clearable v-model="new_temp_quotation_model.quotationName" placeholder="请输入报价名称"></el-input>
          </el-form-item>
          <el-form-item label="报价数量" prop="quotationQty">
            <el-input-number class="w-100" v-model.number="new_temp_quotation_model.quotationQty" type="number"
              :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="申请完成时间" prop="applyCompleteTime">
            <el-date-picker size="small" type="datetime" :placeholder="$t('common.date')"
              v-model="new_temp_quotation_model.applyCompleteTime" style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="描述" prop="Description">
            <el-input type="textarea" clearable v-model="new_temp_quotation_model.Description" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <BaseModal ref="CreateTempItemModal" :title="'创建临时物料'" @saveData="SaveTempItemData" :width="'35%'">
      <template #modal_content>
        <el-form :rules="temp_item_rules" :model="temp_item_model" ref="tempItemForm" label-width="100px"
          class="demo-dataForm">
          <el-form-item label="物料名称" prop="ItemName">
            <el-input clearable v-model="temp_item_model.ItemName" placeholder="请输入物料名称"></el-input>
          </el-form-item>
          <el-form-item label="报价" prop="quotationPrice">
            <el-input-number type="number" class="w-100" v-model.number="temp_item_model.quotationPrice"
              :controls="false"></el-input-number>
          </el-form-item>

          <el-form-item label="描述" prop="Description">
            <el-input type="textarea" clearable v-model="temp_item_model.Description" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <el-dialog title="确认临时报价物料名称" :visible.sync="copyItemVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="copyform" label-width="100px">
        <el-form-item label="物料名称">
          <el-input v-model="copyform.name" class="w100"></el-input>
        </el-form-item>
        <el-form-item label="物料编号">
          <el-input v-model="copyform.num" class="w100"></el-input>
        </el-form-item>
        <el-form-item label="报价">
          <el-input-number v-model="copyform.price" style="width: 100%;"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="copyItemVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCopy">确 定</el-button>
      </div>

    </el-dialog>
    <!-- 附件 -->
    <el-dialog :title="dialog_title" :visible.sync="accessoryVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'TempQuotation'" :showUpload="true"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
    <!-- 物料选择 -->
    <el-drawer :title="'选择物料'" :visible.sync="drawer" :with-header="true" :size="'70%'" @opened="DrawerOpend"
      style="height: calc(100vh)">
      <TableMain :table_height_default="tableHeight + 'px'" ref="TempQuotationItemTable" :show_query_container="false"
        :show_checkbox="false" :selectable="false" :show_date_picker="false" :fields="inventTable_fields"
        :table_height_adjust="8" :title="table_title.title2" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :show_toolbar="false" :pager_count="5" :isBusy="isBusy2"
        :only_text1="$t('common.pub_invent')" @only_methods="only_methods" :hb_table_class="'hb_table_qttable_class3'"
        @current_changed="current_item_changed">
        <template #operation>
          <el-button type="info" plain class="ml-2" @click="getInventIntoDetail"><i
              class="iconfont icon-save"></i>&nbsp;&nbsp;{{ $t('common.ok') }}
          </el-button>
        </template>
      </TableMain>
    </el-drawer>
    <!-- 物料编辑 -->
    <el-drawer :wrapperClosable="false" destroy-on-close :title="select_item_title" :visible.sync="Item_drawer"
      :with-header="true" :size="'80%'" @opened="Item_DrawerOpend" style="height: calc(100vh)">
      <div style="padding: 1rem; height: 100%">
        <el-tabs style="height: 100%">
          <el-tab-pane label="物料" style="height: 100%">
            <TempQuotationCreateItem :SelectItemData="prop_select_data"></TempQuotationCreateItem>
          </el-tab-pane>
          <el-tab-pane label="工艺" lazy style="height: 100%">
            <TempQuotationCreateProcess :SelectItemData="prop_select_data"></TempQuotationCreateProcess>
          </el-tab-pane>
          <el-tab-pane label="成本核算" lazy>
            <TempQuotationPriceCalc :SelectItemData="prop_select_data"></TempQuotationPriceCalc>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as InventTableController from '../../controllers/base/InventTableController'
import * as commonController from '../../controllers/commonController'
import * as TempQuotationController from '../../controllers/sd/TempQuotationController'
import * as TempQuotationCreateItemController from '../../controllers/sd/TempQuotationCreateItemController'
import * as TempQuotationCreateProcessController from '../../controllers/sd/TempQuotationCreateProcessController'
import * as QuotationTaskController from '../../controllers/sd/QuotationTaskController'
import * as SalesOrderController from '../../controllers/sd/SalesOrderController'
import * as localStorageMgr from '../../shared/localStorageMgr'
import SplitContainer2 from '../components/container/SplitContainer2'
import TableMain from '../components/table/TableMain'
import FileUpload from '../FileUpload.vue'
import BaseModal from '../components/modals/baseModal'
import TempQuotationCreateItem from './TempQuotationCreateItem.vue'
import TempQuotationCreateProcess from './TempQuotationCreateProcess.vue'
import TempQuotationPriceCalc from './TempQuotationPriceCalc.vue'

export default {
  components: {
    SplitContainer2,
    TableMain,
    FileUpload,
    BaseModal,
    TempQuotationCreateItem,
    TempQuotationCreateProcess,
    TempQuotationPriceCalc,
  },
  data() {
    return {
      copyform: { name: '', num: '' },
      copyItemVisible: false,
      prop_select_data: null,
      select_item_title: '',
      this_select_item_Current: null,
      thisCurrent: null,
      tableHeight: 200,
      drawer: false,
      Item_drawer: false,
      inventTable_fields: QuotationTaskController.fields.inventTable_fields,
      rules: TempQuotationController.rules,
      temp_item_rules: TempQuotationController.temp_item_rules,
      new_temp_quotation_model: {
        id: '',
        AccountNum: '', //客户账户
        dataAreaId: '', //销售公司
        custName: '', //客户名称
        quotationType: '', //报价类型
        quotationName: '', //报价名称
        quotationQty: 0, //报价数量
        applyCompleteTime: new Date(), //申请完成时间,
        Description: '', //备注
        tempApplyNum: '', //临时申请编号
      },
      //临时物料model
      temp_item_model: {
        ItemId: '',
        ItemName: '',
        quotationPrice: '',
        Description: '',
        isTemp: true,
      },
      new_temp_quotation_modal: '新增临时报价',
      date_picker_label: '',
      date_range: [this.$date.addMonths(new Date(), -6), new Date()],
      query_lable: this.$t('common.query'),
      table_title: {
        title: 'temp_quotation',
        title2: 'table_invent',
      },
      fields: _.cloneDeep(TempQuotationController.fields.temp_quotation),
      ItemId: '',
      isBusy: false,
      isBusy2: false,
      dataAreaId: '',
      custName: '',
      tempApplyNum: '',
      QTOptions: [],
      all_role_users: [],
      onlyMyApproved: true,
      only_un_approved: false,
      SalesQuoteOrderHis: [],
      local_username: '',
      checkedConditions: [2],
      onlyCheckOptions: [
        { value: 1, label: '已完成' },
        { value: 2, label: '处理中' },
      ],
      current_accessory_code: 'VendAccessory',
      current_accessory: null, ///当前供应商选中附件
      accessoryVisible: false,
      dialog_title: '附件列表',
      cust_options: [],
      copy_id: 0,
      copy_tempItemNum: '',
      copy_tempItemName: '',
      copy_data: [],
      copy_params: {},
      copy_item_type: 1
    }
  },
  async created() {
    await this.getAllRoleUsers()
  },
  watch: {
    $route: {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.tempApplyNum = val.query.k
            this.on_query(this.$refs.TempQuotationTable.SetData)
          }
        }
      },
      deep: true,
      // immediate: true
    },
  },
  async mounted() {
    this.local_username = localStorageMgr.get(
      localStorageMgr.data.last_login_account
    )
    // await this.on_query(this.$refs.TempQuotationTable.SetData);
  },
  methods: {
    CustChanged(custId) {
      if (!custId || custId === '') {
        return
      }
      let m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
        CustAccountNum: custId,
      })
      // console.log(m);
      if (m) {
        this.new_temp_quotation_model.dataAreaId = m.DataArea
      } else {
        this.new_temp_quotation_model.dataAreaId = ''
      }
    },
    getBaseDataCust(v) {
      this.cust_options = _.cloneDeep(
        _.orderBy(
          this.$store.state.biz_data.userInfo.user_custs,
          ['modifiedDateTime'],
          ['desc']
        )
      ).splice(0, 200)
      this.cust_options = _.filter(
        _.cloneDeep(this.cust_options),
        function (o) {
          if (o.Blocked === null || o.Blocked.indexOf('否') !== -1) {
            return o
          }
        }
      )
      if (v === 'edit') {
        let cust_num = _.find(this.QuotationTaskModel, {
          key: 'CustAccount',
        }).value
        let _index = _.findIndex(this.cust_options, {
          AccountNum: cust_num,
        })
        if (_index < 0) {
          let _m = _.find(this.$store.state.biz_data.userInfo.user_custs, {
            AccountNum: cust_num,
          })
          this.cust_options.push(_m)
        }
      }
    },
    ///筛选cust
    filterMethod(v) {
      this.cust_options = _.orderBy(
        this.$store.state.biz_data.userInfo.user_custs,
        ['modifiedDateTime'],
        ['desc']
      )
      this.cust_options = _.filter(_.cloneDeep(this.cust_options), (o) => {
        return o.Blocked === null || o.Blocked.indexOf('否') !== -1
      })
      if (v) {
        this.cust_options = _.filter(this.cust_options, (t) => {
          let seiName = _.toUpper(t.SEI_Name),
            _v = _.toUpper(v)
          if (t.AccountNum.indexOf(v) > -1 || seiName.indexOf(_v) > -1) {
            return t
          }
        })
      }
      this.cust_options = this.cust_options.splice(0, 300)
    },
    clearModel() {
      this.new_temp_quotation_model = {
        id: '',
        AccountNum: '', //客户账户
        dataAreaId: '', //销售公司
        custName: '', //客户名称
        quotationType: '', //报价类型
        quotationName: '', //报价名称
        quotationQty: 0, //报价数量
        applyCompleteTime: new Date(), //申请完成时间,
        Description: '', //备注
        tempApplyNum: '', //临时申请编号
      }
    },
    //创建临时物料
    createTempItem() {
      let qt_order = this.$refs.TempQuotationTable.GetCurrentItem()
      if (!qt_order) {
        this.msgToasts('请选择临时报价申请单主档！', 'info')
        return
      }
      if (qt_order.tempItemNum) {
        this.msgToasts('已存在临时物料！', 'info')
        return
      }
      if (qt_order.ItemId) {
        this.msgToasts('已存在正式物料！', 'info')
        return
      }
      this.temp_item_model.ItemName = ''
      this.temp_item_model.quotationPrice = 0
      this.temp_item_model.Description = ''
      this.$refs.CreateTempItemModal.show()
    },
    //新增物料
    createData() {
      this.new_temp_quotation_modal = '新增临时报价'
      this.clearModel()
      this.getBaseDataCust()
      this.$refs.QTModal.show()
    },
    //保存临时物料或正式物料
    async SaveTempItemData(cb) {
      this.$refs.tempItemForm.validate(async (valid) => {
        if (valid) {
          let p = {}
          let rt = null
          if (this.temp_item_model.isTemp) {
            p.id = this.thisCurrent.id //主档id
            p.tempItemName = this.temp_item_model.ItemName //临时物料名称
            p.quotationPrice = this.temp_item_model.quotationPrice //报价
            p.Description = this.temp_item_model.Description //备注
            rt = await TempQuotationController.methods.saveTempItemData(p)
          } else {
            p.id = this.thisCurrent.id //主档id
            p.ItemName = this.temp_item_model.ItemName //物料名称
            p.ItemId = this.temp_item_model.ItemId //物料编号
            p.quotationPrice = this.temp_item_model.quotationPrice //报价
            p.Description = this.temp_item_model.Description //备注
            rt = await TempQuotationController.methods.saveItemData(p)
          }
          if (rt) {
            let m = _.find(this.$refs.TempQuotationTable.my_data, {
              id: rt[0].id,
            })
            if (m) {
              for (let key in m) {
                if (rt[0].hasOwnProperty(key)) {
                  m[key] = rt[0][key]
                }
              }
              this.$refs.TempQuotationTable.SetCurrentItem(m)
              cb(true, true)
            }
          }
        } else {
          cb(true, false, '')
          return
        }
      })
    },
    async SaveData(cb) {
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //新增或保存过程
          if (this.new_temp_quotation_model.id === '' && this.new_temp_quotation_modal != '复制临时报价申请')
            await this.addTempQuotation(cb)
          else if (this.new_temp_quotation_model.id === '' && this.new_temp_quotation_modal == '复制临时报价申请')
            await this.copyTempQuotation(cb)
          else await this.updateTempQuotation(cb)
        } else {
          cb(true, false, '')
          return
        }
      })
    },
    async updateTempQuotation(cb) {
      let cust = _.find(this.cust_options, {
        AccountNum: this.new_temp_quotation_model.AccountNum,
      })
      if (cust) this.new_temp_quotation_model.custName = cust.SEI_Name
      let rt = await TempQuotationController.methods.saveData(
        this.new_temp_quotation_model
      )
      if (rt) {
        let m = _.find(this.$refs.TempQuotationTable.my_data, {
          id: rt[0].id,
        })
        if (m) {
          for (let key in m) {
            if (rt[0].hasOwnProperty(key)) {
              if (key === 'applyCompleteTime') m[key] = new Date(rt[0][key])
              else m[key] = rt[0][key]
            }
          }
          this.$refs.TempQuotationTable.SetCurrentItem(m)
          cb(true, true)
        } else cb(true, false, '')
      } else cb(true, false, '')
    },
    async addTempQuotation(cb) {
      let cust = _.find(this.cust_options, {
        AccountNum: this.new_temp_quotation_model.AccountNum,
      })
      if (cust) this.new_temp_quotation_model.custName = cust.SEI_Name
      let rt = await TempQuotationController.methods.saveData(
        this.new_temp_quotation_model
      )
      if (rt) {
        this.$refs.TempQuotationTable.InsertItems(rt[0])
        cb(true, true)
      } else cb(true, false, '')
    },
    async confirmCopy() {
      if (!this.copyform.name || !this.copyform.num || !this.copyform.price) {
        this.msgToasts('信息不能为空', 'info')
        return;
      }
      if (this.copy_item_type === 1) {
        this.copy_params.tempItemNum = this.copyform.num
        this.copy_params.tempItemName = this.copyform.name
      } else {
        this.copy_params.ItemId = this.copyform.num
        this.copy_params.ItemName = this.copyform.name
      }
      this.copy_params.quotationPrice = this.copyform.price

      let rt = await TempQuotationController.methods.copyData(this.copy_params)
      if (rt) {
        this.msgToasts('复制成功', 'success')
        this.on_query(this.$refs.TempQuotationTable.SetData)
        this.copyItemVisible = false
      }
    },
    async copyTempQuotation(cb) {
      let cust = _.find(this.cust_options, {
        AccountNum: this.new_temp_quotation_model.AccountNum,
      })
      this.copy_params = { 'custName': '', 'AccountNum': '', 'dataAreaId': '', 'quotationType': '', 'quotationQty': 0, 'quotationName': '', 'applyCompleteTime': '', 'Description': '', 'tempItemNum': '', 'tempItemName': '', 'ItemId': null, 'ItemName': null, 'quotationPrice': 0, 'QuotationId': 0 }

      if (cust) this.new_temp_quotation_model.custName = cust.SEI_Name
      this.copy_params.custName = cust.SEI_Name
      this.copy_params.AccountNum = cust.AccountNum
      this.copy_params.dataAreaId = this.new_temp_quotation_model.dataAreaId
      this.copy_params.quotationType = this.new_temp_quotation_model.quotationType
      this.copy_params.quotationQty = this.new_temp_quotation_model.quotationQty
      this.copy_params.quotationName = this.new_temp_quotation_model.quotationName
      this.copy_params.applyCompleteTime = this.new_temp_quotation_model.applyCompleteTime
      this.copy_params.Description = this.new_temp_quotation_model.Description
      this.copy_params.QuotationId = this.copy_id
      //弹出对话框 获取 选择的item名称和num
      this.copyItemVisible = true;
      this.copyform.name = this.copy_tempItemName
      this.copyform.num = this.copy_tempItemNum
      this.copyform.price = this.copy_price
      cb(false)
    },
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近90天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      }
    },
    ///获取临时报价申请编号
    async getKvTempQuote(query = '') {
      let p = { is_deleted: { '=': 0 } }
      p.tempApplyNum = { like: '%' + query + '%' }
      let _result = await TempQuotationController.methods.getData(p, 'kv')
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_result[0], function (t) {
          return {
            value: t.tempApplyNum,
            label: t.dataAreaId + ':' + t.tempApplyNum,
          }
        })
        this.QTOptions = _.orderBy(dt.slice(0, 300), ['value'], ['desc'])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvTempQuote(query)
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    myApproveChange(list) {
      let _roles = []
      let _username = this.$global.global_data.local_username
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          'code'
        )
      }
      let _list = []
      _.each(list, (t) => {
        if (!_.isNull(t.fcGetSQOrderApprover) && t.fcGetSQOrderApprover) {
          let name_or_role = t.fcGetSQOrderApprover.split(',')[0]
          let _is_role = t.fcGetSQOrderApprover.split(',')[1]
          if (_is_role === 1) {
            if (_.includes(_roles, name_or_role)) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          } else {
            if (_username === name_or_role) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          }
        }
      })
      return _list
    },
    //公共物料查询
    only_methods(isAllCust, isPublic) {
      if (this.thisCurrent) {
        this.$refs.TempQuotationItemTable.SetData([])
        this.Invent_Query(this.thisCurrent.dataAreaId, isPublic)
      }
    },
    //查询物料
    async Invent_Query(dataAreaId, isPublic = false) {
      this.isBusy2 = true
      let p = {}
      p.publicItem = 2
      if (isPublic) p.publicItem = 0
      p.dataAreaId = dataAreaId
      let _result = await InventTableController.methods.getSOInventData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.TempQuotationItemTable.SetData(
          _.orderBy(_result[0], ['createdDateTime'], ['desc'])
        )
      }
      this.isBusy2 = false
    },
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let hasDate = true
      let p = {}
      if (this.dataAreaId != '') {
        p.dataAreaId = this.dataAreaId
        hasDate = false
      }
      if (this.tempApplyNum && this.tempApplyNum != '') {
        p.tempApplyNum = _.trim(this.tempApplyNum)
        hasDate = false
      }
      if (!_.isNull(this.date_range) && hasDate) {
        let _toDate = this.$date.format(this.date_range[1], 'yyyy-MM-dd')
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          'yyyy-MM-dd'
        )
        p.date_from = this.$date.format(this.date_range[0], 'yyyy-MM-dd')
        p.date_to = _toDate
      }
      let _result = await TempQuotationController.methods.getData(p)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (m) => {
          m.AccessoryCount = 0
          if (m.Accessory && m.Accessory != '')
            m.AccessoryCount = JSON.parse(m.Accessory).length
          //this.getApprover(m);
        })
        //this.only_methods(this.checkedConditions);
      }
      set_data(_.orderBy(_result[0], ['id'], ['desc']))
      this.isBusy = false
    },
    getApprover(t) {
      commonController.methods.getUserNameFromRole(
        this.all_role_users,
        t,
        'fcGetSQOrderApprover',
        'SQOrderApprover',
        t.fcCheckSQOrderApproved
      )
    },
    current_changed(old, current) {
      this.thisCurrent = current
      // console.log(this.thisCurrent);
    },
    current_item_changed(old, current) {
      this.this_select_item_Current = current
    },
    //#endregion
    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length === 0) {
        this.msgToasts(this.$t('notify.not_data'), 'info')
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t('notify.is_continue'))
      if (!ask) {
        cb(false)
        return
      }

      let p = {},
        approve_dt = []
      if (data.state == 'approved' || data.state == 'unapproved') {
        let refused_exists = _.some(data.selected_items, { isOrderRefused: 1 })
        if (data.state == 'approved' && refused_exists) {
          this.msgToasts('已退回数据不能执行该操作！', 'info')
          cb(false)
          return
        }
        let approved_exists = _.some(data.selected_items, {
          fcCheckSQOrderApproved: true,
        })
        if (data.state == 'approved' && approved_exists) {
          this.msgToasts('已审批数据不能执行该操作！', 'info')
          cb(false)
          return
        }
        let dt = _.filter(data.selected_items, (t) => {
          return t.fcCheckSQOrderApproved == !(data.state == 'approved')
        })
        approve_dt = _.cloneDeep(dt)
        let check_ap_res = []
        ///检查是否有该权限
        let _check_ap_params = {
          list: _.map(_.cloneDeep(dt), (t) => {
            t.id = t.quotationtask_detail_id
            return t
          }),
          DocumentType: 'SalesQuoteOrder',
          approve_type: '',
          isNotCheckPrivilage: data.state == 'approved' ? false : true,
          action_state: data.state == 'approved',
        }
        check_ap_res = await commonController.methods.checkApprovePrivilige(
          _check_ap_params,
          this
        )

        if (check_ap_res.notPriviligeIdList.length > 0) {
          this.msgToasts(
            `抱歉，暂无审批编号（${_.join(
              check_ap_res.notPriviligeIdList,
              '，'
            )}）的权限！`,
            'error'
          )
          cb(false)
          return
        }
        p.approved = {}
        p.approved.data = []
        p.approved.local_username = this.$global.global_data.local_username
        let _approveStatusIdList = _.filter(check_ap_res.approveStatusIdList, {
          isApproved: data.state == 'approved' ? false : true,
        })

        p.approved.approveStatusIdList = _.orderBy(
          _approveStatusIdList,
          ['ApproveLevel'],
          ['asc']
        )
        let confirm_m = await this.$prompt('请输入审批意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入审批意见',
          inputValue: '同意',
        })
          .then(({ value }) => {
            return { state: true, val: value }
          })
          .catch(() => {
            return { state: false }
          })
        if (confirm_m && confirm_m.state) {
          p.approved.ApproveRemark = confirm_m.val
        } else return
      }
      if (data.state == 'refused') {
        let dt = _.filter(data.selected_items, (t) => {
          return t.fcCheckSQOrderApproved == false
        })
        approve_dt = _.cloneDeep(dt)
        if (dt && dt.length == 0) {
          this.msgToasts('已审批数据不能执行该操作！', 'info')
          cb(false)
          return
        }
        let confirm_m = await this.$prompt('请输入退回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入原因',
        })
          .then(({ value }) => {
            return { state: true, val: value }
          })
          .catch(() => {
            return { state: false }
          })

        if (confirm_m && confirm_m.state) {
          p.approved = {}
          p.approved.data = []
          _.each(data.selected_items, (t) => {
            p.approved.data.push({
              id: t.quotationtask_detail_id,
              SQOrderDescription: confirm_m.val,
            })
          })
        } else {
          cb(false)
          return
        }
      }
      let loading = this.$loading({
        lock: true,
        text: this.$t('notify.waiting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let rt = await TempQuotationController.methods.saveData(p)
      if (rt) {
        await this.on_query(this.$refs.TempQuotationTable.SetData, false)
        await setTimeout(async () => {
          ///审批后发邮件
          if (data.state === 'approved' || data.state === 'refused') {
            let email_user = [],
              email_next_dt = [],
              email_last_dt = []
            _.each(approve_dt, (t) => {
              let m = _.find(this.SalesQuoteOrderHis, {
                quotationtask_detail_id: t.quotationtask_detail_id,
              })
              if (m && m.fcGetSQOrderApprover && data.state === 'approved') {
                email_user.push(m.fcGetSQOrderApprover.split(',')[0])
                email_next_dt.push(m)
              }
              email_user = _.uniqWith(email_user, _.isEqual)
              ///整理审批完成或者拒批发邮件的数据
              let last_m = _.find(this.SalesQuoteOrderHis, (mt) => {
                return (
                  mt.quotationtask_detail_id == t.quotationtask_detail_id &&
                  (mt.fcCheckSQOrderApproved || mt.isOrderRefused == 1)
                )
              })
              if (last_m) email_last_dt.push(last_m)
            })
            //发送邮件给下一审批人
            if (email_next_dt.length > 0) {
              let p = _.map(email_next_dt, (t) => {
                return { DetailId: t.quotationtask_detail_id, IsHomemade: '' }
              })
              await commonController.handleEmailNotify(
                p,
                'quote_order_confirm',
                this,
                null,
                'email_get_quote_data',
                email_user
              )
            }
            //审批完成发送给报价申请创建人
            if (email_last_dt.length > 0)
              await this.SendEmail(email_last_dt, data.state)
          }
          this.msgToasts(this.$t('notify.action_successfully'), 'success')
          cb(true)
          loading.close()
        }, 1500)
      } else {
        this.msgToasts(this.$t('notify.action_unsuccessfully'), 'error')
        cb(false)
      }
    },

    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {
      if (data.tool == 'adhoc_report') {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t('table.table_customer'),
          sheet_title: '部件档案',
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    ///发送报价申请处理邮件
    async SendEmail(data, action_type) {
      this.email_action_type = action_type
      let p = _.map(data, (t) => {
        return { QuotationTaskNum: t.QuotationTaskNum }
      })
      p = _.uniqWith(p, _.isEqual)
      await commonController.handleEmailNotify(
        p,
        'quote_order_approved',
        this,
        this.all_role_users,
        'get_quotation_order'
      )
    },
    //#endregion

    //#region 附件
    on_cell_button_click(data) {
      this.thisCurrent = data.item
      if (data.field.key == 'id') {
        this.new_temp_quotation_modal = '编辑临时报价申请'
        for (let key in this.new_temp_quotation_model) {
          if (data.item.hasOwnProperty(key)) {
            if (key == 'applyCompleteTime')
              this.new_temp_quotation_model[key] = new Date(data.item[key])
            else this.new_temp_quotation_model[key] = data.item[key]
          }
        }
        this.$refs.QTModal.show()
      } else if (data.field.key == 'Accessory') {
        this.current_accessory = data.item
        this.accessoryVisible = true
      } else if (data.field.key == 'tempItemNum') {
        this.select_item_title = `物料名称:${data.item.tempItemName}  报价数量:${data.item.quotationQty}`
        this.prop_select_data = data.item
        this.Item_drawer = true
      } else if (data.field.key == 'ItemId') {
        this.select_item_title = `物料名称:${data.item.ItemName}  报价数量:${data.item.quotationQty}`
        this.prop_select_data = data.item
        this.Item_drawer = true
      } else if (data.field.key == 'action') {
        this.new_temp_quotation_modal = '复制临时报价申请'
        if (!data.item['tempItemNum'] && !data.item['ItemId']) {
          this.msgToasts('该报价没有物料,无法复制！', 'info')
          return
        }
        for (let key in this.new_temp_quotation_model) {
          if (data.item.hasOwnProperty(key)) {
            if (key == 'applyCompleteTime')
              this.new_temp_quotation_model[key] = new Date(data.item[key])
            else this.new_temp_quotation_model[key] = data.item[key]

          }
        }
        this.new_temp_quotation_model.tempApplyNum = ''
        this.copy_tempItemNum = data.item['tempItemNum'] ? data.item['tempItemNum'] : data.item['ItemId']
        this.copy_tempItemName = data.item['tempItemName'] ? data.item['tempItemName'] : data.item['ItemName']
        this.copy_price = data.item['quotationPrice']
        this.copy_item_type = data.item['tempItemName'] ? 1 : 2
        this.copy_id = JSON.parse(JSON.stringify(this.new_temp_quotation_model.id))
        this.new_temp_quotation_model.id = ''
        this.getBaseDataCust()
        this.$refs.QTModal.show()
        // console.log(this.cust_options)
      }
    },
    bottomDialogOpened() {
      let _accessory = this.current_accessory.Accessory
      this.$refs.refAccessory.getAccessory(
        _accessory,
        this.current_accessory.id
      )
    },
    async dialogClosed() {
      if (this.current_accessory && this.current_accessory.Accessory) {
        let m = {
          id: this.current_accessory.id,
          Accessory: this.current_accessory.Accessory,
        },
          ml = []
        if (m.id && m.id != '') ml.push(m)
        this.current_accessory.AccessoryCount = JSON.parse(
          this.current_accessory.Accessory
        ).length
        await TempQuotationController.methods.updateAccessory({ edit: ml })
      }
    },
    async bottomSetAccessory(data) {
      this.current_accessory.Accessory = data
      await this.dialogClosed()
    },
    //打开物料选择
    showInventView() {
      let qt_order = this.$refs.TempQuotationTable.GetCurrentItem()
      if (!qt_order) {
        this.msgToasts('请选择临时报价申请单主档！', 'info')
        return
      }
      if (qt_order.tempItemNum) {
        this.msgToasts('已存在临时物料！', 'info')
        return
      }
      if (qt_order.ItemId) {
        this.msgToasts('已存在正式物料！', 'info')
        return
      }
      this.tableHeight = this.$refs.TempQuotationTable.$el.clientHeight - 130
      this.drawer = true
      this.this_select_item_Current = null
    },
    async DrawerOpend() {
      let qt_order = this.$refs.TempQuotationTable.GetCurrentItem()
      this.$refs.TempQuotationItemTable.SetData([])
      this.$refs.TempQuotationItemTable.only_value1 = false
      this.Invent_Query(qt_order.dataAreaId)
    },
    //物料打开弹窗事件
    async Item_DrawerOpend() { },
    ///将选中物料添加到明细
    getInventIntoDetail() {
      let selected_invent_data =
        this.$refs.TempQuotationItemTable.GetCurrentItem()
      // console.log(selected_invent_data)
      this.temp_item_model.ItemId = selected_invent_data.ItemId
      this.temp_item_model.ItemName = selected_invent_data.NameAlias
      this.temp_item_model.quotationPrice = 0
      this.temp_item_model.Description = ''
      this.temp_item_model.isTemp = false
      this.$refs.CreateTempItemModal.show()
      if (!selected_invent_data) {
        this.msgToasts(this.$t('notify.not_data'), 'info')
        return
      }
      // _.each(selected_invent_data, (t) => {
      //   this.Detail_CreateData(t)
      // })
      this.drawer = false
    },
    //#endregion
  },
}
</script>
<style>
.hb_table_quotationorder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 195rem;
}
</style>
